(function () {
  'use strict';

  const attributionKeys = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'fbclid', 'gclid', 'tw_source', 'tw_adid'
  ];

  function preserveAttribution(root) {
    const incoming = new URLSearchParams(window.location.search);
    root.querySelectorAll('a[data-ed-product-link]').forEach(function (link) {
      const href = link.getAttribute('href');
      if (!href) return;
      try {
        const destination = new URL(href, window.location.href);
        if (destination.origin !== window.location.origin) return;
        let changed = false;
        attributionKeys.forEach(function (key) {
          const value = incoming.get(key);
          if (value && value.trim() && !destination.searchParams.has(key)) {
            destination.searchParams.set(key, value.slice(0, 500));
            changed = true;
          }
        });
        if (changed) link.setAttribute('href', destination.href);
      } catch (_) {
        // An invalid destination must not interrupt the educational controls.
      }
    });
  }

  function trackCta(link) {
    if (new URLSearchParams(window.location.search).has('ezlift_qa') ||
        window.Shopify?.designMode || !Array.isArray(window.dataLayer)) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return;
    try {
      if (privacy.analyticsProcessingAllowed() !== true) return;
    } catch (_) {
      return;
    }
    const detail = {
      event: 'ezlift_funnel_cta',
      funnel: 'educational-creative',
      placement: link.dataset.edCta
    };
    if (link.dataset.edVariant) detail.variant_id = link.dataset.edVariant;
    window.dataLayer.push(detail);
  }

  function initialize() {
    const root = document.getElementById('ezlift-education');
    if (!root || root.dataset.edInitialized) return;
    root.dataset.edInitialized = 'true';

    const controls = root.querySelector('[data-ed-controls]');
    const buttons = Array.from(root.querySelectorAll('button[data-ed-feature]'));
    const panels = Array.from(root.querySelectorAll('[data-ed-panel]'));
    const selectFeature = function (key) {
      if (!panels.some(function (panel) { return panel.dataset.edPanel === key; })) return;
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.edFeature === key));
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.edPanel !== key; });
    };

    if (controls && buttons.length && panels.some(function (panel) { return panel.dataset.edPanel === 'stand'; })) {
      selectFeature('stand');
      controls.hidden = false;
    }

    preserveAttribution(root);
    root.addEventListener('click', function (event) {
      const target = event.target;
      if (typeof target?.closest !== 'function') return;
      const button = target.closest('button[data-ed-feature]');
      if (button && root.contains(button)) selectFeature(button.dataset.edFeature);
      const link = target.closest('a[data-ed-cta]');
      if (link && root.contains(link)) trackCta(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
